import { Howl, Howler } from 'howler';

export default class AudioManager {
  sounds = new Map();

  soundConfigs = [];

  constructor(sounds) {
    this.soundConfigs = sounds;
    this.loadSounds(sounds);
    AudioManager.instance = this;
    AudioManager.handleVisibilityChange();
  }

  loadSounds(sounds) {
    this.sounds.clear();

    sounds.forEach((sound) => {
      const { src, ...remaining } = sound;
      const loadedSound = new Howl({
        src,
        ...remaining,
      });

      loadedSound.name = sound.name;
      loadedSound.type = sound.type;

      this.sounds.set(sound.name, loadedSound);
    });
  }

  getSound(name) {
    return this.sounds.get(name);
  }

  play(name) {
    AudioManager.resumeAudioContext();
    const sound = this.getSound(name);
    sound?.play();
  }

  stop(name) {
    const sound = this.getSound(name);
    sound?.stop();
  }

  isPlaying(name) {
    const sound = this.getSound(name);
    return sound ? sound.playing() : false;
  }

  static async resumeAudioContext() {
    if (!Howler.ctx || Howler.ctx.state === 'closed') {
      AudioManager.reinitializeAudio();
      return;
    }

    if (Howler.ctx.state === 'suspended') {
      try {
        await Howler.ctx.resume();
      } catch (e) {
        // eslint-disable-next-line
        console.warn('Failed to resume audio context:', e);
        AudioManager.reinitializeAudio();
      }
    }
  }

  static reinitializeAudio() {
    // Unload and clear existing sounds
    AudioManager.instance?.sounds.forEach(howl => howl.unload());
    AudioManager.instance?.sounds.clear();

    // Reset Howler
    Howler.unload();
    Howler.ctx.close().catch(() => {});
    Howler.ctx = new (window.AudioContext || window.webkitAudioContext)();
    Howler.masterGain = Howler.ctx.createGain();
    Howler.masterGain.gain.setValueAtTime(1, Howler.ctx.currentTime);
    Howler.masterGain.connect(Howler.ctx.destination);

    // Reload all sounds
    AudioManager.instance?.loadSounds(AudioManager.instance?.soundConfigs);
  }

  static handleVisibilityChange() {
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        AudioManager.reinitializeAudio();
      }
    });

    window.addEventListener('focus', () => {
      AudioManager.reinitializeAudio();
    });
  }
}
